export default {
    USER: 1000,
    SYS_ADMIN: 1001,
    CALC_EXCESS: 1002,
    UPDATE_CARDPAYMENT_STATUS: 1003,
    VIEW_TASK_HISTORY: 1004,
    RESET_POLICY: 1007
}